export default "__VITE_ASSET__5c9aee3b__"